import { render, staticRenderFns } from "./AhDescription.vue?vue&type=template&id=27972546&scoped=true&lang=pug&"
import script from "./AhDescription.vue?vue&type=script&lang=js&"
export * from "./AhDescription.vue?vue&type=script&lang=js&"
import style0 from "./AhDescription.vue?vue&type=style&index=0&id=27972546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27972546",
  null
  
)

export default component.exports